<template>
  <div
    data-test-id="user-avatar"
    class="user-avatar"
    :class="{
      'user-avatar--blank': useBlank,
      'user-avatar--initials': initials && !image && !useBlank,
      'user-avatar--small': size === 'small',
      'user-avatar--big': size === 'big',
    }"
    :style="style"
  >
    <template v-if="!image && initials && !useBlank">
      {{ initials }}
    </template>

    <UserIcon v-if="useBlank" class="user-avatar__icon" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UserIcon from '@components/Icons/UserIcon.vue';

export default defineComponent({
  name: 'UserAvatar',

  components: {
    UserIcon,
  },

  props: {
    image: {
      default: undefined,
      type: String,
    },

    firstname: {
      default: undefined,
      type: String,
    },

    lastname: {
      default: undefined,
      type: String,
    },

    blank: {
      default: false,
      type: Boolean,
    },

    size: {
      type: String,
      required: false,
      default: 'normal',
    },
  },

  computed: {
    style() {
      return this.image ? `background-image: url(${this.image})` : null;
    },

    initials(): string {
      if (!(this.firstname && this.lastname)) return null;

      return this.firstname.charAt(0) + this.lastname.charAt(0);
    },

    useBlank(): boolean {
      return this.blank || (!this.image && !this.initials);
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'settings/settings';

.user-avatar {
  background: transparent;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: colors.$color-white;
  border-radius: 50%;
  background-position: center center;
  background-size: cover;
  font-size: 14px;
  user-select: none;
}

.user-avatar--small {
  width: 20px;
  height: 20px;
  font-size: 10px;
  border-radius: settings.$border-radius;
}

.user-avatar--big {
  width: 40px;
  height: 40px;
  font-size: 16px;
}

.user-avatar--blank {
  background: colors.$color-grey-100;
}

.user-avatar__icon {
  color: colors.$color-grey-500;
}

.user-avatar--initials {
  background: colors.$color-grey-blue-100;
}
</style>
